module.exports = __webpack_public_path__ + "img/git_logo2.42d1bd17.svg";